module.exports = __webpack_public_path__ + "static/audio-converter-slide-7cbc0fdec883014cc9f7f4672dfdbc89.jpg";